// @ts-nocheck
import React, { useCallback, useState } from 'react';

import StatusRefuel from 'components/Granel/StatusRefuel';
import { useMediaQuery } from 'react-responsive';
import { getRangeDateRefuel } from 'utils/getRangeDateRefuel';
import moment from 'moment';
import Loading from 'components/layout/loading';
import { BsEye } from 'react-icons/bs';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { getStatusType } from 'newComponents/NewNotifications/NotificationItem/util';
import Pagination from '../Pagination';
import ModalDetails from './ModalDetails';

import { useTrackingRefuel } from '../../../hooks/useTrackingRefuel';

import {
  Button,
  StyledTable,
  TableWrapper,
  TableContainer,
  TableData,
  TableHeader,
  TableRow,
  Tbody,
  Thead,
  Tr,
  ModalDetailComponent,
  ButtonMobile,
  ButtonWrapper,
} from './styles';

const Table: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [activePage, setActivePage] = useState(1);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const {
    isLoading,
    dataPages,
    currentPage,
    totalPages,
    totalPerPage,
    nextPage,
    prevPage,
    handleSetPage,
    handleTotalPerPage,
    dataDetail,
    getRefuelsByCaseId,
    orderStatus,
  } = useTrackingRefuel();

  const handleClickDetail = (item: any): void => {
    const { caseId, supplyId } = item;
    getRefuelsByCaseId(caseId, supplyId);
    setShowModal(true);
  };

  const handleNextPage = useCallback(() => {
    if (activePage === 3) return;
    setActivePage(activePage + 1);
  }, [activePage]);

  const handleBackPage = useCallback(() => {
    if (activePage === 1) return;
    setActivePage(activePage - 1);
  }, [activePage]);

  return (
    <>
      {isLoading && <Loading />}
      <TableWrapper>
        <TableContainer>
          <StyledTable>
            {!isMobile && (
              <Thead>
                <Tr>
                  <TableHeader>Data do pedido</TableHeader>
                  <TableHeader>Número do pedido</TableHeader>
                  <TableHeader>Base</TableHeader>
                  <TableHeader>Previsão de entrega</TableHeader>
                  <TableHeader>Status</TableHeader>
                  <TableHeader />
                </Tr>
              </Thead>
            )}
            {isMobile && (
              <Thead>
                <Tr>
                  {activePage === 1 && (
                    <>
                      <TableHeader>Data do pedido</TableHeader>
                      <TableHeader>Número do pedido</TableHeader>
                    </>
                  )}
                  {activePage === 2 && (
                    <>
                      <TableHeader>Base</TableHeader>
                      <TableHeader>Previsão de entrega</TableHeader>
                    </>
                  )}
                  {activePage === 3 && (
                    <TableHeader isLast={activePage === 3}>Status</TableHeader>
                  )}
                  <TableHeader>
                    <ButtonWrapper>
                      <ButtonMobile
                        onClick={handleBackPage}
                        disabled={activePage === 1}
                      >
                        <BiChevronLeft size={24} color="#3D3D3D" />
                      </ButtonMobile>
                      <ButtonMobile
                        onClick={handleNextPage}
                        disabled={activePage === 3}
                      >
                        <BiChevronRight size={24} color="#3D3D3D" />
                      </ButtonMobile>
                    </ButtonWrapper>
                  </TableHeader>
                </Tr>
              </Thead>
            )}
            <Tbody>
              {dataPages?.length === 0 && (
                <TableRow>
                  <TableData colSpan={6}>Nenhum pedido encontrado</TableData>
                </TableRow>
              )}
              {dataPages?.length > 0 &&
                dataPages?.map((item) => {
                  const statusResponse = getStatusType(
                    item?.status.code,
                    'refuel',
                    true
                  );
                  return (
                    <>
                      {!isMobile && (
                        <TableRow key={item.caseNumber}>
                          <TableData>
                            {moment(item.createdDate).format('DD/MM/YYYY')}
                          </TableData>
                          <TableData>
                            {item.orderNumber ?? 'Processando'}
                          </TableData>
                          <TableData>{item.installBaseName}</TableData>
                          <TableData>
                            {statusResponse === 'Em analise'
                              ? '-'
                              : getRangeDateRefuel(
                                  item.forecastDate,
                                  item?.beginDate ?? null,
                                  item?.endDate ?? null,
                                  item?.suggestedDate ?? null,
                                  item?.agreedDate ?? null,
                                  item?.reprogrammingDate ?? null,
                                  null,
                                  statusResponse
                                )}
                          </TableData>
                          <TableData>
                            <StatusRefuel
                              statusCode={item?.status.code}
                              newOrigin
                            />
                          </TableData>
                          <TableData onClick={() => handleClickDetail(item)}>
                            <Button>Ver detalhes</Button>
                          </TableData>
                        </TableRow>
                      )}
                      {isMobile && (
                        <TableRow key={item.caseNumber}>
                          {activePage === 1 && (
                            <>
                              <TableData>
                                {moment(item.createdDate).format('DD/MM/YYYY')}
                              </TableData>
                              <TableData>
                                {item.orderNumber ?? 'Processando'}
                              </TableData>
                            </>
                          )}
                          {activePage === 2 && (
                            <>
                              <TableData>{item.installBaseName}</TableData>
                              <TableData>
                                {statusResponse === 'Em analise'
                                  ? '-'
                                  : getRangeDateRefuel(
                                      item.forecastDate,
                                      item?.beginDate ?? null,
                                      item?.endDate ?? null,
                                      item?.suggestedDate ?? null,
                                      item?.agreedDate ?? null,
                                      item?.reprogrammingDate ?? null,
                                      null,
                                      statusResponse
                                    )}
                              </TableData>
                            </>
                          )}
                          {activePage === 3 && (
                            <TableData isLast={activePage === 3}>
                              <StatusRefuel
                                statusCode={item?.status.code}
                                newOrigin
                              />
                            </TableData>
                          )}
                          <TableData onClick={() => handleClickDetail(item)}>
                            <BsEye size={24} color="#0b29fb" />
                          </TableData>
                        </TableRow>
                      )}
                    </>
                  );
                })}
            </Tbody>
          </StyledTable>
        </TableContainer>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalPerPage={totalPerPage}
          handleSetPage={handleSetPage}
          nextPage={nextPage}
          prevPage={prevPage}
          handleTotalPerPage={handleTotalPerPage}
        />
      </TableWrapper>
      <ModalDetailComponent
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        animation={false}
      >
        <ModalDetails
          dataDetail={dataDetail}
          orderStatus={orderStatus}
          isLoading={isLoading}
          closeModal={() => setShowModal(false)}
        />
      </ModalDetailComponent>
    </>
  );
};

export default Table;
